import { LogLevel, BrowserCacheLocation } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: "884883ce-6358-4dc6-b166-178c78620a9a",
        tenantId: "829c3abd-b89c-4d79-a1fb-6d8644f2fb53",
        authority: "https://login.microsoftonline.com/829c3abd-b89c-4d79-a1fb-6d8644f2fb53/v2.0",
        redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URL
    },
    cache: {
        cacheLocation: BrowserCacheLocation.SessionStorage,
        storeAuthStateInCookie: false,
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    // case LogLevel.Info:
                    //     console.info(message);
                    //     return;
                    // case LogLevel.Verbose:
                    //     console.debug(message);
                    //     return;
                    // case LogLevel.Warning:
                    //     console.warn(message);
                    //     return;
                    default:
                        return;
                }	
            }	
        }	
    }
};